var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('Header')],1),(this.$route.name !== 'home')?_c('div',{staticClass:"container"},[_c('b-breadcrumb',{attrs:{"items":_vm.crumbs}})],1):_vm._e(),_c('div',{staticClass:"container w-100 h-100"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }